import type { z } from 'zod'
import type { AnyValue } from './utility-types.ts'

export const satisfiesSchema = <Schema extends z.ZodTypeAny>(
  schema: Schema,
  input: AnyValue
): input is z.infer<Schema> => schema.safeParse(input).success
